import {PlayType} from "../../libs/types/page-home.types";
import {createSlice} from "@reduxjs/toolkit";
import {RootState} from "../index";

interface IStateSlice {
    playType: PlayType | null
}

const initialState: IStateSlice = {
    playType: null
}

export const typeIssueSortingSlices = createSlice({
    name: 'typeIssueSortingSlices',
    initialState,
    reducers: {
        setNewPlayType: (state, {payload}) => {
            state.playType = payload
        },
        resetPlayType: (state) => {
            state.playType = null
        }
    }
})

export const {setNewPlayType, resetPlayType} = typeIssueSortingSlices.actions

export const getPlayTypeToStore = (store: RootState) => store.typeIssueSortingSlices